import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useAiStatus } from "./api";
import "./ai.css";

/** Кнопка Coca AI в шапке: радужная вращающаяся рамка, свечение, искры → презентация /ai (с ключом ИИ на сервере — живой помощник). */
export function AiButton() {
  const { t } = useTranslation();
  const label = useAiStatus().live ? t("ai.chat.button") : t("ai.button");
  return (
    <Link to="/ai" className="ai-cta shrink-0" aria-label={label} title={label}>
      <span className="ai-cta__inner">
        <Sparkles className="ai-cta__icon size-4" strokeWidth={2.25} aria-hidden />
        <span className="ai-cta__text text-sm">AI</span>
      </span>
      <span className="ai-spark ai-spark--1" aria-hidden />
      <span className="ai-spark ai-spark--2" aria-hidden />
      <span className="ai-spark ai-spark--3" aria-hidden />
    </Link>
  );
}
